// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2yRwY","search":"Settings_search__2jyFX","filter":"Settings_filter__1xelV"};